import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconShare';
/** Renders an SVG icon. */
const SvgShare = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="m20.345 18.112-5.39 3.828-1.16-1.63 5.391-3.829zm-.672-5.768-.846 1.812-7.5-3.5.846-1.812z"
      />
      <path
        fill="currentColor"
        d="M11 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0m2 0A5 5 0 1 1 3 8a5 5 0 0 1 10 0m1 15a3 3 0 1 0-6 0 3 3 0 0 0 6 0m2 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0m10-8a3 3 0 1 0-6 0 3 3 0 0 0 6 0m2 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0"
      />
    </svg>
  );
};
SvgShare.displayName = displayName;
export default SvgShare;
